import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tright: 0;\n\tleft: 0;\n\tbottom: ", ";\n\tpointer-events: none;\n\tdisplay: flex;\n\tflex-direction: row-reverse;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tbackground: transparent;\n\tpadding: 0;\n\tborder: none;\n\tline-height: 0;\n\tcursor: pointer;\n\tcolor: ", ";\n\tborder-bottom: 1px solid transparent;\n\tpointer-events: initial;\n\t:hover {\n\t\tcolor: ", ";\n\t}\n\t:focus {\n\t\tcolor: ", ";\n\t\t", "\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { styled } from '../../theme-provider';
import { getLabelIconColor } from '../utils';
import { Close } from '@volkswagen-onehub/icons-core';
import { createA11yOutlineStyles } from '../../helpers';
var StyledClearButton = styled.button.withConfig({
  displayName: "StyledClearButton",
  componentId: "sc-1o29182"
})(_templateObject(), getLabelIconColor, function (props) {
  return props.theme.interaction.recipe400.hover;
}, function (props) {
  return props.theme.interaction.recipe400.hover;
}, function (props) {
  return createA11yOutlineStyles(props);
});
var StyledClearButtonWrapper = styled.div.withConfig({
  displayName: "StyledClearButtonWrapper",
  componentId: "sc-1guav8u"
})(_templateObject2(), function (props) {
  return props.theme.size.static200;
});
export var TextFieldCleanWrapper = function TextFieldCleanWrapper(props) {
  var appearance = props.appearance,
      children = props.children,
      onClear = props.onClear,
      clearIconLabel = props.clearIconLabel,
      hasClearButton = props.hasClearButton,
      isClearButtonVisible = props.isClearButtonVisible;
  return React.createElement(React.Fragment, null, children, hasClearButton && isClearButtonVisible && React.createElement(StyledClearButtonWrapper, null, React.createElement(StyledClearButton, {
    appearance: appearance,
    "aria-label": clearIconLabel,
    title: clearIconLabel,
    onClick: onClear,
    type: "button"
  }, React.createElement(Close, {
    variant: "default"
  }))));
};
TextFieldCleanWrapper.displayName = 'TextFieldCleanWrapper';